import { locationsArr, PeriodsLookup } from "../../../constants/data_arrays";
import DateField from '../../../controls/Date';
import TextField from '../../../controls/TextField';
import AutocompleteControl from '../../../controls/Autocomplete';
import MuiAutocomplete from '@mui/material/Autocomplete';
import { Grid } from "@mui/material";
import React, { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import moment, { Moment } from "moment";
import Dropdown from "../../../controls/Select";
type Props = {
  editCap: {
    mode: boolean,
    id: number
  } | false
};

const FormData: FC<Props> = ({ editCap }) => {

  const { register, errors, setValue, watch, getValues, trigger } = useFormContext();
  const { activeStart, activeEnd, origins, states, /*campaigns,*/ period, customerTypes } = watch();

  const customerTypeOptions = [
    { label: 'Ineligible Return', value: 1 },
    { label: 'Active Return', value: 2 },
    { label: 'Inactive Return', value: 3 },
    { label: 'Retention', value: 4 },
    { label: 'Unconverted Approval', value: 5 },
    { label: 'New Customer', value: 6 },
  ];

  useEffect(() => {
    register({ name: 'activeStart' }, {
      required: 'Required',
      validate: (d: Moment) => {
        const end = getValues('activeEnd');
        return !end || moment(d).isBefore(end) || 'Start Date must be earlier than End Date';
      }
    });
    register({ name: 'activeEnd' }, {
      required: 'Required',
      validate: (d: Moment) => {
        const start = getValues('activeStart');
        return !start || moment(d).isAfter(start) || 'End Date must be later than Start Date';
      }
    });
    register({ name: 'period' }, { required: 'Required' });
    register({ name: 'states' }, { required: 'Required' });
    register({ name: 'origins' });
    register({ name: 'campaigns' });
    register({ name: 'customerTypes' });
    // eslint-disable-next-line 
  }, [register])

  return (
    <Grid container alignContent={'flex-start'} justifyContent={'center'} direction={'row'} spacing={2} >
      <Grid item xs = {5}>
        <TextField
          fullWidth
          name={'name'}
          label={'Name'}
          inputRef={register({ required: 'Required' })}
          error={Boolean(errors.name)}
          helperText={errors.name?.message || ' '} />
      </Grid>

      <Grid item xs = {5}>
        <TextField fullWidth name={'amount'}
          label={'Amount'}
          type="number"
          inputProps={{ min: 0, ref: register({ required: 'Required', validate: (v) => Number(v) >= 0 }) }}
          error={Boolean(errors.amount)}
          helperText={errors.amount?.message || (errors.amount && 'Not a valid number') || ' '} />
      </Grid>

      <Grid item xs = {5}>
        <DateField
          name={'activeStart'}
          label={'Active Start'}
          fullWidth
          value={activeStart}
          onChange={(m: Moment | null) => {
            setValue('activeStart', m, { shouldValidate: true });
            trigger('activeEnd');
          }}
          error={Boolean(errors.activeStart)}
          helperText={errors.activeStart?.message || ' '} />
      </Grid>

      <Grid item xs = {5}>
        <DateField name={'activeEnd'}
          label={'Active End'}
          fullWidth
          value={activeEnd}
          onChange={(m: Moment | null) => {
            setValue('activeEnd', m, { shouldValidate: true });
            trigger('activeStart');
          }}
          error={Boolean(errors.activeEnd)}
          helperText={errors.activeEnd?.message || ' '} />
      </Grid>
      <Grid item xs={10}>
        <AutocompleteControl options={[]} label={'Origins'}
          value={origins}
          onChange={(e: React.SyntheticEvent, v: string[]) => {
            const pasteMerge = v.reduce<string[]>((c, p) => {
              const n = p.split(';');
              for (let i = 0; i < n.length; i++) {
                c.push(n[i]);
              }
              return c;
            }, []);
            setValue('origins', pasteMerge, { shouldValidate: true })
          }}
          getOptionLabel={(option: any) => option.toString()}
          name={'origins'}
          freeSolo={true}
          fullWidth
          error={Boolean(errors.origins)}
          helperText={errors.origins?.message || ' '}
          limitTags={20} />


      </Grid>
      <Grid item xs={5}>
        <AutocompleteControl options={locationsArr} label={'States'}
          name={'states'}
          fullWidth
          freeSolo={true}
          value={states}
          onChange={(e: React.SyntheticEvent, v: string[]) =>
            setValue('states', v)}
          error={Boolean(errors.states)}
          helperText={errors?.states?.message || ' '}
          limitTags={5} />

      </Grid>

      <Grid item xs={5}>
        <MuiAutocomplete
          multiple
          options={customerTypeOptions}
          getOptionLabel={(option) => option.label}
          value={customerTypeOptions.filter(o => (customerTypes || []).includes(o.value))}
          onChange={(e, v) => setValue('customerTypes', v.map(o => o.value), { shouldValidate: true })}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label={'Cap'}
              error={Boolean(errors.customerTypes)}
              helperText={errors.customerTypes?.message || ' '}
            />
          )}
          fullWidth
        />
      </Grid>

      <Grid item xs={5}>
        <Dropdown
          fullWidth
          value={period || ''}
          label={'Periods'}
          name={'period'}
          options={[{ label: 'Periods', value: '', disabled: true }, ...PeriodsLookup]}
          onChange={(e) => setValue('period', e.target.value, { shouldValidate: true })}
          error={Boolean(errors.period)}
          helperText={errors.period?.message || ' '} />
      </Grid>
    </Grid>
  );
};
export default FormData;
